import type { MigrationObject } from './types/migration';
import { getLatestDataVersion } from './service/version-service';
import { migrations } from './migrations-provider';
import { DATA_VERSION } from './dataVersions';

/**
 * Migrates a save file to the latest dataversion. Will iterate all available migrationscripts until data is up to date
 * @param saveFileData Data to be migrated from save file
 */
export const migrate = (saveFileData: any) => {
  let migrationObject: MigrationObject = {
    message: undefined,
    state: saveFileData,
  };

  if (migrationObject.state.dataVersion === undefined) {
    migrationObject = migrations[DATA_VERSION.DATA_VERSION0].apply(null, [
      migrationObject,
    ]);
  }

  const maxMigrations = Object.keys(migrations).length;
  let doneMigrations = 0;
  const latestVersion = getLatestDataVersion();

  // Handle files with dataVersion higher than current latest version
  // This can happen when DATA_VERSION enums are removed from the codebase
  if (migrationObject.state.dataVersion > latestVersion) {
    // eslint-disable-next-line no-console
    console.log(
      `File has dataVersion ${migrationObject.state.dataVersion} which is higher than latest ${latestVersion}. Downgrading to latest version.`,
    );
    migrationObject.state = {
      ...migrationObject.state,
      dataVersion: latestVersion,
    };
  }

  while (
    migrationObject.state.dataVersion !== latestVersion &&
    doneMigrations < maxMigrations
  ) {
    const currentVersion = migrationObject.state.dataVersion;
    const migrationFn = migrations[currentVersion];
    if (!migrationFn) {
      throw new Error(
        `Migration function for version ${currentVersion} is undefined. Available migrations: ${Object.keys(
          migrations,
        ).join(', ')}`,
      );
    }
    migrationObject = migrationFn.apply(null, [migrationObject]);
    doneMigrations++;
  }

  return migrationObject;
};
